import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
  TablePagination,
  Box,
  Paper,
} from '@mui/material'

import { showSnackbar } from '@context/SnackbarContext'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import { useSelector, useDispatch } from 'react-redux'
import AddrPopup from '@components/AddrPopup'
import RecvPopup from '@components/RecvPopup'
import WebService from '@util/webService'
import { comma } from '@src/util/helper'
import useAlert from '@hooks/useAlert'
import FlatButton from '@components/FlatButton'
import * as ExcelJS from 'exceljs'
import axios from 'axios'
import MyDialog2 from '@components/MyDialog2'
import MyDialog3 from '@components/MyDialog3'
import { check } from 'prettier'
import { setLoading } from '@context/LoadingContext'
import MyPagination from '@components/MyPagination'
import ConfirmDialog from '@components/ConfirmDialog'
import { EditOutlined } from '@mui/icons-material'
import { emailRegex, nameRegex, passwordRegex } from '@util/helper'
import { MoreHorizOutlined } from '@mui/icons-material'
import ArrowBackOutlined from '@mui/icons-material/ArrowBackOutlined'
const boldFont = {
  fontWeight: 'bold',
}

const defPageInfo = { pageNum: 0, pageSize: 10 }
const BranchInfo = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const account = useSelector((state) => state.accountReducer)
  const codes = useSelector((state) => state.codeReducer)
  const statCodes = codes.filter((r) => r.codeGroupId === 'C002')
  const [records, set_records] = useState([])
  const navigate = useNavigate()
  const location = useLocation()
  // 지점목록에서 진입: state = { branch, pack(지점목록) }
  // 계약상세에서 복귀: state = { pack: { url, branch, prevPack(지점목록) } }
  const fromList = !!location.state?.branch
  const branch = fromList ? location.state?.branch : location.state?.pack?.branch
  const pack = fromList ? location.state?.pack : location.state?.pack?.prevPack
  const curLocationRef = useRef(location)
  const { alert, renderAlert } = useAlert()
  const dgRef = useRef()
  const dgHandler = useState(false)
  const [pageInfo, set_pageInfo] = useState(pack?.data ?? defPageInfo)
  const roomRef = useRef(null)

  const fetchRooms = async() => {
    const url = branch?.id ? `/room/branch/${branch.id}` : `/room/all`


    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    return records
  }



  const onLoad = async () => {
    const records = await fetchRooms()
    console.log('rooms=>', records)
    if(records) {
      set_records(records.filter(r => r.id > 0))
    }
  }

  const onClear = async (roomId) => {
    const url = `/room/clear/${roomId}`
    const resp = await WebService.post(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    set_pageInfo({...pageInfo})
    showSnackbar('처리되었습니다.')
  }

  // 지점목록에서 넘어온 pack(url, pageInfo)으로 복귀: 목록의 페이지 위치 유지
  const onBack = () => {
    if (pack?.url) {
      navigate(pack.url, {
        replace: true,
        state: {
          pack: pack,
        },
      })
    }
    else {
      navigate(-1)
    }
  }

  // 계약상세(AdminOrderView)로 이동: 상세의 onBack이 pack.url로 돌아오므로 branch와 지점목록 pack을 함께 담아 둠
  const onMoveOrder = (order) => {
    navigate('/admin/order/view', {
      state: {
        order: order,
        pack: {
          url: window.location.pathname,
          branch: branch,
          prevPack: pack,
        },
      },
    })
  }

  useEffect(() => {
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      onLoad()
    }
  }, [location])

  useEffect(() => {
    if (!account?.user?.id) {
      navigate('/login')
    } else {
      onLoad()
    }
  }, [pageInfo])


  const RoomOrder= ({order}) => {
    return(
      <div style={{cursor:'pointer'}} onClick={() => onMoveOrder(order)}>
          <Typography fontStyle={{fontWeight:'bold', color:'#0D47A1'}} style={{textDecoration:'underline'}}>{order.companyName}</Typography>
          <Typography variant='body2' fontStyle={{color:'#0D47A1'}}>{order.startTime.substring(0,10)} ~ {order.endTime.substring(0,10)}</Typography>
          <Typography variant='body2' fontStyle={{color:'#0D47A1'}}>신청: {order.regTime}</Typography>
          <Typography variant='body2' fontStyle={{color:'#0D47A1'}}>{statCodes.find(r => r.code === order.statCode)?.name}</Typography>
      </div>
    )

  }
  const MoreOrder = () => {
    useEffect(() => {
    },[])
    return(
      <div>
        <Grid container spacing={2} >
          {
            roomRef.current.orders.sort((a, b) => (b.id - a.id)).map((o, idx) => (
              <Grid item xs={12}>
                <RoomOrder order={o}/>
              </Grid>
            ))
          }
        </Grid>
      </div>
    )
  }
  const GridRoomInfo = () => {
    return(
      <>
        {dgHandler[0] ? (<MyDialog3 title={`${roomRef.current?.roomNo} 호실현황`} dialogHandler={dgHandler} component={<MoreOrder />} windowWidth='sm' />): null}
        {/* <MyDialog2 title={`${roomRef.current?.roomNo} 호실현황`} ref={dgRef} component={<MoreOrder />} windowWidth='sm' /> */}
        {
        records.map((branch, idx) => (

          <Grid key={idx} item xs={12}>
            {
              (() => {
                const multiRoomStr = branch.rooms.filter(r => r.useYn === 'Y' && r.orders.length >= 2).sort((a, b) => (a.id - b.id)).reduce((r, ridx) => {
                  return r.id + ' '
                },'')
              })()
            }
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='h5' style={{fontWeight:'bold'}}>{branch.branchName}</Typography>
              </Grid>
              <Grid item xs={12} >
                <Typography>사용중인 호실: {branch.rooms.filter(r => r.useYn === 'Y').length} 개 </Typography>
                <Typography style={{display:'flex'}}>다중입주 호실:
                {
                  (() => {
                    const multiRoomStr = branch.rooms.filter(r => r.useYn === 'Y' && r.orders.length >= 2).sort((a, b) => (a.id - b.id)).map(r => r.roomNo).join(',')
                    if(multiRoomStr.length > 0) {
                      return ' ' + multiRoomStr + ' 호'
                    }
                    else {
                      return ' 없음'
                    }

                  })()
                } </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {
                    branch.rooms.sort((a, b) => +a.id - +b.id).map((r, idx2) =>(
                      <Grid key={idx2} item xs={12} md={2.4} onMouseOver={() => (roomRef.current = r)} >
                          <Paper elevation={0}
                            style={{
                              border:'1px solid silver', minHeight:50, padding:5,
                              backgroundColor:r.useYn === 'Y' ? '#E1F5FE' : '#fff'
                            }}
                          >
                              <div style={{display:'flex', flexDirection:'row',alignItems:'center', marginBottom:5}}>
                                <Typography style={{marginRight:10}}>{r.roomNo} 호</Typography>
                                {
                                  r.useYn === 'Y' ? (
                                    <ConfirmDialog
                                      btn={<Button size='small' variant='contained' color='warning' style={{marginRight:5}}>사용해제</Button>}
                                      title={'알림'}
                                      content={'사용 해제하시겠습니까?'}
                                      bc={'primary'}
                                      preHandle={ async () => {
                                        return true
                                      }}
                                      perform={() => {
                                        onClear(r.id)
                                      }}
                                    />
                                  ) : null
                                }

                              </div>
                              {
                                r.useYn === 'Y' ? (
                                  r.orders.length > 0 ? (
                                    r.orders.sort((a,b) => b.id - a.id).map((o,idx3) => (
                                      idx3 === 0 ? (
                                        <div style={{marginBottom:3,}}>
                                          <RoomOrder order={o}/>
                                        </div>
                                      ) : (
                                        idx3 === 1 ? (
                                          <IconButton onClick={() => {
                                            dgHandler[1](true)
                                          }}>
                                            <MoreHorizOutlined/>
                                          </IconButton>
                                        ) : null
                                      )
                                    ))
                                  ) : (
                                      <Typography fontStyle={{fontWeight:'bold', color:'#B71C1C'}}>알수 없음</Typography>
                                  )
                                ) : null
                              }
                          </Paper>
                      </Grid>
                    ))
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))
       }
      </>
    )
  }

  return (
    <div style={{ paddingTop: isMobile ? 50 : 30}}>
      {renderAlert()}
      <Container style={{}}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <IconButton style={{ backgroundColor: '#fafafa' }} onClick={onBack}>
              <ArrowBackOutlined />
            </IconButton>
          </Grid>
          <GridRoomInfo />
        </Grid>
      </Container>
    </div>
  )
}

export default BranchInfo
